import { lazy } from 'react'

export const SupportServiceLazy = lazy(() => import('./SupportService'))
